import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faXmark } from '@fortawesome/free-solid-svg-icons';

const CustomModal = ({ open, setOpen, children, }) => {
    return (

        < >
            {
                open &&
                <div className={`modal-wrap`}  >
                    <div className='bg-primary shadow-xl  w-[340px] rounded p-5 pt-3 md:w-[700px]'>
                        <div className='flex justify-end items-center w-full   text-white text-[24px]'>
                            <button onClick={() => setOpen(false)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </button>

                        </div>
                        {children}
                    </div>
                </div>
            }
            {
                open &&
                <div className={`fixed  flex justify-center items-center inset-0 bg-black/50`} onClick={() => { setOpen(pre => !pre) }}>
                </div>
            }
        </>

    );
};

export default CustomModal;